import React, { useEffect } from "react";
import './style.css'
import { useNavigate, useParams  } from "react-router-dom";
import EmployeeList from "../../../components/DashboardComponents/EmployeeDetails/EmployeeList";

const BranchSettingsPage = ({setActivePath}) => {

    const navigate = useNavigate ();
    const { branchId } = useParams();

    useEffect(() => {
        setActivePath("Manage Branch");
      }, [setActivePath]);

    const handleGoBack = () => {
        navigate('/store/branches');
    };



  return (
    <div className="outlet-container">
       <div className="back-arrow" onClick={handleGoBack}>
        &lt; Back
      </div>
      <div className="branch-settings-title">Branch Settings</div>
      <div>Branch ID: {branchId}</div> {/* Display branchId */}

      <EmployeeList/>
    </div>
  )
}

export default BranchSettingsPage
